// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/angular-carousel/dist/angular-carousel.min.css
// module id = 376
// module chunks = 0